import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeliveryCostComponent } from './delivery-cost.component';
import { CmsConfig, FeaturesConfigModule, I18nModule, provideConfig } from '@spartacus/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormErrorsModule } from '@spartacus/storefront';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { OccDeliveryCost } from './delivery-cost.occ';
import { LocalLoaderComponent } from '../../../../../../components/loader/local-loader/local-loader.component';

@NgModule({
  declarations: [DeliveryCostComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    FormErrorsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    LocalLoaderComponent,
    FeaturesConfigModule,
  ],
  providers: [
    provideNgxMask(),
    provideConfig(OccDeliveryCost),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        DeliveryCost: {
          component: DeliveryCostComponent,
        },
      },
    }),
  ],
  exports: [DeliveryCostComponent],
})
export class DeliveryCostModule {}
